import { Component, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BrazeService } from 'src/app/services/braze.service';
import { CurrencyState } from 'src/app/_models/state/optionUIState';
import { ReportsComponent } from '../reports/reports.component';

@Component({
  selector: 'app-reports-button',
  templateUrl: './reports-button.component.html',
  styles: [],
})
export class ReportsButtonComponent {
  @Input() routeId: number;
  @Input() disabled: boolean;
  @Input() displayCurrency: CurrencyState;

  constructor(
    private modalService: BsModalService,
    private brazeService: BrazeService
  ) {}

  showReports() {
    this.brazeService.track('Reports');
    this.modalService.show(ReportsComponent, {
      class: 'modal-xl reports-modal',
      ignoreBackdropClick: true,
      initialState: {
        routeId: this.routeId,
        displayCurrency: this.displayCurrency,
      },
    });
  }
}
